import script from "./NoteCrudDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./NoteCrudDropdown.vue?vue&type=script&setup=true&lang=js"

import "./NoteCrudDropdown.vue?vue&type=style&index=0&id=78dcd334&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78dcd334"]])

export default __exports__